import { EmptyState } from '@/components/EmptyState';
import { ProblemAlert } from '@/components/ProblemAlert';
import { ResolveForm } from './ResolveForm';
import { ResolveResult } from './ResolveResult';
import { useResolvePreview, type ResolveInitial } from './useResolvePreview';

/** "Resolve" preview: the effective env of app + environment + platform with precedence chips, missing requirements and warnings. */
export function ResolvePreview(props: ResolveInitial) {
  const r = useResolvePreview(props);
  return (
    <div className="flex flex-col gap-4 p-4 sm:p-5" data-testid="env-resolve">
      <ResolveForm r={r} apps={props.apps} environments={props.environments} />
      <ProblemAlert error={r.error} testId="env-resolve-problem" />
      {r.result ? <ResolveResult result={r.result} /> : <EmptyState compact icon="account_tree" title="Effective environment" description="The same algorithm that creates a build's snapshot, without creating one: precedence org → project → project+env → app → app+env → app+env+platform → overrides." />}
    </div>
  );
}
